import { useUser } from '@clerk/clerk-react'
import { hasPermission, resolveRole, type PermissionAction, type UserRole } from '@orientamos/shared'

export function usePermissions() {
  const { user } = useUser()
  const role: UserRole = resolveRole(user?.publicMetadata)

  return {
    role,
    isSuperadmin: role === 'superadmin',
    can: (action: PermissionAction) => hasPermission(role, action),
  }
}
